const initialState = {
    tokenUpdateSuccessFlag: false,
    isLoaderStatus: false
};

const SecurePaymentReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_TOKEN_UPDATE_SUCCESS':{
            return  {
                ...state,
                tokenUpdateSuccessFlag:action.value
            }
        }
        case 'SET_LOADER_STATUS':{
            return  {
                ...state,
                isLoaderStatus:action.value
            }
        }
        default:
            return state;
    }

};

export default SecurePaymentReducer;
